﻿/**
* DevExpress Analytics (query-builder\wizard\pages\objectDataSourceWizard\configureObjectDataSourceParametersPage.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var wizardPage_1 = require("../wizardPage");
var objectDataSource_1 = require("../../../dataSource/object/objectDataSource");
var _chooseObjectParameters_1 = require("../../internal/objectDataSource/_chooseObjectParameters");
var pageId_1 = require("../../pageId");
var localization_utils_1 = require("../../../../property-grid/localization/localization_utils");
var ConfigureObjectDataSourceParametersPage = (function (_super) {
    __extends(ConfigureObjectDataSourceParametersPage, _super);
    function ConfigureObjectDataSourceParametersPage(itemsProvider) {
        var _this = _super.call(this) || this;
        _this._objectDataSource = new objectDataSource_1.ObjectDataSource();
        _this._disposables.push(_this._chooseObjectParameters = new _chooseObjectParameters_1.ChooseObjectMemberParameters(itemsProvider));
        return _this;
    }
    ConfigureObjectDataSourceParametersPage.prototype.canNext = function () {
        return false;
    };
    ConfigureObjectDataSourceParametersPage.prototype.canFinish = function () {
        return true;
    };
    ConfigureObjectDataSourceParametersPage.prototype.commit = function () {
        return $.Deferred().resolve({
            selectedType: this._objectDataSource.selectedType,
            ctor: this._objectDataSource.ctor,
            dataMember: this._objectDataSource.dataMember,
            dataSourceName: this._objectDataSource.name(),
        }).promise();
    };
    ConfigureObjectDataSourceParametersPage.prototype.initialize = function (state) {
        this._objectDataSource.setState(state);
        this._chooseObjectParameters.updateCtorParameters(this._objectDataSource.ctor);
        this._chooseObjectParameters.updateMethodParameters(this._objectDataSource.dataMember);
        return $.Deferred().resolve().promise();
    };
    return ConfigureObjectDataSourceParametersPage;
}(wizardPage_1.WizardPageBase));
exports.ConfigureObjectDataSourceParametersPage = ConfigureObjectDataSourceParametersPage;
function _registerConfigureObjectDataSourceParametersPage(factory, getItemsProviderCallback) {
    factory.registerMetadata(pageId_1.ObjectDataSourceWizardPageId.ConfigureParametersPage, {
        setState: function (data, state) {
            state.ctor = data.ctor;
            state.dataMember = data.dataMember;
            state.selectedType = data.selectedType;
        },
        getState: function (state) {
            return state.objectDataSourceWizard;
        },
        resetState: function (state, defaultState) {
            state.dataMember = defaultState.dataMember;
        },
        create: function () {
            return new ConfigureObjectDataSourceParametersPage(getItemsProviderCallback && getItemsProviderCallback());
        },
        description: localization_utils_1.getLocalization('Configure constructor parameters and/or method parameters.', 'AnalyticsCoreStringId.ObjectDSWizard_ConfigureParameters_Description'),
        template: 'dx-objectdatasource-configureparameters-page'
    });
}
exports._registerConfigureObjectDataSourceParametersPage = _registerConfigureObjectDataSourceParametersPage;
